(function(){
'use strict';

const esc = s => (s==null?'':String(s)).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));

const DAYS = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'];
const MONTHS = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
const MONTHS_SHORT = ['jan','fév','mars','avr','mai','juin','juil','août','sept','oct','nov','déc'];  // 'juin'/'juillet' se confondent en slice(0,3)

// Sort order: smallest → largest, intime first
const SIZE_ORDER = ['Intimiste','Grandes scènes','Zénith','Stades & Arena'];

const STATE = {
  venues: [],              // salles de la ville de la page (venuesOf)
  counts: new Map(),       // dbName → count of upcoming
  nextByVenue: new Map(),  // dbName → next event
  typeFilter: 'all'
};

const CONFIG = {debout:'Debout', assis:'Assis', modulable:'Assis ou debout'};

// Salles de la ville de la page (js/villes.js) : a Paris, les fiches de
// venues-data.js ; partout, les salles de province de la ville (data/villes.json),
// qui n'ont ni histoire ni metro mais une commune, parfois une adresse.
function venuesOf(ville){
  const villes = window.LAgendaVilles;
  const paris = (!ville || ville.slug === 'paris') ? window.VENUES_DATA.map(v => ({
    dbName: v.dbName, names: v.names || [v.dbName], slug: v.slug, display: v.display, type: v.type,
    year: v.year, capacity: v.capacity, tagline: v.tagline, metro: v.metro, hex: v.hex
  })) : [];
  const province = ville ? villes.sallesDeLaVille().map(s => ({
    dbName: s.venue, names: [s.venue], slug: s.slug, display: s.nom, type: villes.taille(s),
    year: null, capacity: s.capacite,
    tagline: [s.commune !== ville.nom ? s.commune : null, CONFIG[s.configuration]].filter(Boolean).join(' · '),
    metro: s.adresse || '', hex: villes.couleur(s.slug)
  })) : [];
  return paris.concat(province);
}

async function loadCounts(ville){
  const byName = new Map();
  for (const v of STATE.venues) for (const n of v.names) byName.set(n, v.dbName);
  const villes = window.LAgendaVilles;
  try{
    const list = villes && villes.fetchSources
      ? await villes.fetchSources(ville ? ville.sources : ['/data/events_upcoming.json'])
      : await fetch('/data/events_upcoming.json').then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
    const now = new Date(); now.setHours(0,0,0,0);
    for (const e of list){
      if (!e.date || !e.venue) continue;
      if (e.category!=null && e.category!=='concert') continue;
      const key = byName.get(e.venue);
      if (!key) continue;
      const d = new Date(e.date + 'T00:00:00');
      if (d < now) continue;
      STATE.counts.set(key, (STATE.counts.get(key)||0)+1);
      const cur = STATE.nextByVenue.get(key);
      if (!cur || d < cur.dateObj){
        STATE.nextByVenue.set(key, {dateObj:d, name:e.event_name});
      }
    }
  } catch(err){
    console.warn('[salles] load failed', err);
  }
}

// Par taille, de la plus intime a la plus grande ; les salles de taille
// inconnue a la fin, par nombre de dates.
function sortedVenues(){
  const rank = v => { const i = SIZE_ORDER.indexOf(v.type); return i < 0 ? SIZE_ORDER.length : i; };
  return STATE.venues.slice().sort((a,b) =>
    (rank(a) - rank(b)) || ((a.capacity||0) - (b.capacity||0))
    || ((STATE.counts.get(b.dbName)||0) - (STATE.counts.get(a.dbName)||0)));
}

function renderFilters(){
  const types = new Map();
  for (const v of STATE.venues) if (v.type) types.set(v.type, (types.get(v.type)||0)+1);
  const ordered = SIZE_ORDER.filter(t => types.has(t));
  const pills = [`<button class="pill ${STATE.typeFilter==='all'?'active':''}" data-t="all">Toutes<span class="n">${STATE.venues.length}</span></button>`]
    .concat(ordered.map(t => `<button class="pill ${STATE.typeFilter===t?'active':''}" data-t="${esc(t)}">${esc(t)}<span class="n">${types.get(t)}</span></button>`));
  $('#salles-filters').innerHTML = pills.join('');
  $$('#salles-filters .pill').forEach(b => b.addEventListener('click', () => {
    STATE.typeFilter = b.dataset.t;
    renderFilters();
    renderGrid();
  }));
}

function renderGrid(){
  const list = sortedVenues().filter(v => STATE.typeFilter==='all' || v.type===STATE.typeFilter);
  $('#salles-grid').innerHTML = list.map(cardHtml).join('');
}

function cardHtml(v){
  const count = STATE.counts.get(v.dbName) || 0;
  const next = STATE.nextByVenue.get(v.dbName);
  const nextStr = next
    ? `Prochain · <span class="n">${DAYS[next.dateObj.getDay()]} ${next.dateObj.getDate()} ${MONTHS_SHORT[next.dateObj.getMonth()]}</span>`
    : `<span class="n">Agenda vide</span>`;
  return `
  <a class="vcard" href="/salle/${esc(v.slug)}/" style="--_vc:${v.hex}">
    <div class="vcard-top">
      <span class="type">${esc(v.type || 'Salle')}${v.year?` · ${v.year}`:''}</span>
      ${v.capacity ? `<span class="cap">${v.capacity.toLocaleString('fr-FR')} places</span>` : ''}
    </div>
    <h2>${esc(v.display)}</h2>
    <p class="tagline">${esc(v.tagline||'')}</p>
    <div class="metro">${esc(v.metro||'')}</div>
    <div class="vcard-foot">
      <span class="next">${nextStr}</span>
      <span class="arrow">${count} à venir →</span>
    </div>
  </a>`;
}

async function boot(){
  const villes = window.LAgendaVilles;
  if (villes) await villes.ready;
  const ville = villes ? villes.current() : null;
  // Page de ville dont l'index des villes n'a pas repondu : sa grille, rendue
  // au build avec ses compteurs, reste telle quelle — jamais les salles de
  // Paris sous le nom d'une autre ville.
  if (!ville && villes && villes.metaVille && villes.metaVille !== 'paris') return;
  STATE.venues = venuesOf(ville);
  const sub = $('#salles-sub');
  if (sub && ville) sub.textContent = `${STATE.venues.length} adresses ${ville.a_nom} et alentours, de la plus intime à la plus grande. Chacune a son agenda.`;
  // Page de ville rendue au build (generate_city_pages.py) : ses cartes ont deja
  // leurs compteurs. Les redessiner sans (« Agenda vide ») avant de les
  // recharger ferait clignoter toute la grille.
  const prerendered = !!$('#salles-grid') && $('#salles-grid').children.length > 0;
  if (!prerendered){
    renderFilters();
    renderGrid();
  }
  await loadCounts(ville);
  renderFilters();
  renderGrid();
  const total = Array.from(STATE.counts.values()).reduce((s,n)=>s+n,0);
  $('#foot-stats').textContent = `${STATE.venues.length} salles · ${total} concerts à venir`;
}

document.addEventListener('DOMContentLoaded', boot);
})();
